import { useApplication } from '@eneco/common/application';
import { useAddressFinderQueryStringDefaultValues } from '@eneco/components/AddressFinder/hooks/useAddressFinderQueryStringDefaultValues';

import { BuildingAgeType, BuildingType } from '../types';

export const useCalculationToolQueryParameters = () => {
  const { searchParams } = useApplication();

  // Normalize query parameters (convert keys to lowercase)
  const normalizedParams: Record<string, string> = {};
  searchParams.forEach((value, key) => {
    normalizedParams[key.toLowerCase()] = value;
  });

  return {
    // Ensures query parameters are case-insensitive by normalizing their keys. This improves accessibility and flexibility.
    ...(normalizedParams['solarpanelsoutput'] && {
      solarPanelsOutput: Number(normalizedParams['solarpanelsoutput']),
    }),
    ...(normalizedParams['usageelectricitylow'] && {
      usageElectricityLow: Number(normalizedParams['usageelectricitylow']),
    }),
    ...(normalizedParams['usageelectricityhigh'] && {
      usageElectricityHigh: Number(normalizedParams['usageelectricityhigh']),
    }),
    ...(normalizedParams['usagegas'] && {
      usageGas: Number(normalizedParams['usagegas']),
    }),
    ...(normalizedParams['ismoving'] && {
      isMoving: normalizedParams['ismoving'] === 'true',
    }),
    ...(normalizedParams['singlefuel'] && {
      onlySingleFuelElectricity: normalizedParams['singlefuel'] === 'true',
    }),
    ...(normalizedParams['hassolarpanels'] && {
      hasSolarPanels: normalizedParams['hassolarpanels'] === 'true',
    }),
    ...(normalizedParams['knownusage'] && {
      knownUsage: normalizedParams['knownusage'] === 'true',
    }),
    ...(normalizedParams['hasdoublemeter'] && {
      hasDoubleMeter: normalizedParams['hasdoublemeter'] === 'true',
    }),
    ...(normalizedParams['vouchercode'] && {
      voucherCode: normalizedParams['vouchercode'] || '',
    }),
    ...(normalizedParams['residents'] && {
      residents: Number(normalizedParams['residents']),
    }),
    ...(normalizedParams['buildingtype'] && {
      buildingType: normalizedParams['buildingtype'] as BuildingType,
    }),
    ...(normalizedParams['buildingage'] && {
      buildingAge: normalizedParams['buildingage'] as BuildingAgeType,
    }),
  };
};

export const useConvertAddressQueryParams = () => {
  const { houseNumber, postalCode, houseNumberSuffix } = useAddressFinderQueryStringDefaultValues();

  return {
    houseNumber: houseNumber ? Number(houseNumber) : undefined,
    postalCode,
    houseNumberSuffix,
  };
};
